import { memo, MouseEventHandler } from 'react';
import { CameraSvg } from '@/sub-luca-plugin/compatible-components/svg-icons';
import { toastInQa, uploadLimit } from '@/sub-luca-plugin/utils/qa';
import { eventBusExample } from '@/sub-luca-plugin/utils/class-example';
import { Upload } from '@/sub-luca-plugin/compatible-components';
import { getQaStore } from '@/sub-luca-plugin/store/qa';
import { tCommon } from '@/sub-luca-plugin/i18n';
import './index.scss';

const OcrLabel = () => {
    // Ocr功能上传图片后的回调
    const handleUploadChangeOfOcr = (info: any) => {
        const localUrl = URL.createObjectURL(info.file as File);
        eventBusExample.publish('PictureCrop', { type: 'crop', params: { url: localUrl } });
    };

    // 流输出过程中阻止使用ocr功能的图片上传
    const handleCanUploadOfOcr: MouseEventHandler = event => {
        !getQaStore()!.validateCanSend(['replying', 'ocrAndGptReplying']) && event.stopPropagation();
    };

    return (
        <Upload accept=".jpg, .jpeg, .png" showUploadList={false} beforeUpload={uploadLimit} customRequest={handleUploadChangeOfOcr}>
            <div className="dialogue-tool-stream-controls__upload-picture" onClick={handleCanUploadOfOcr}>
                <CameraSvg className="dialogue-tool-stream-controls__upload-picture-icon" />
                <span>{tCommon.t('snapAnswer', '拍题答疑')}</span>
            </div>
        </Upload>
    );
};

export default memo(OcrLabel);
